export default __webpack_public_path__ + "static/media/IMG_3543.a38a53c8.jpg";